import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IConfirmResponse } from "@interfaces/auth";
import useAppState from "../../contexts/state";
import { auth } from "@services/auth/auth-service";
import { LoaderCircle } from "lucide-react";
import toast from "react-hot-toast";

const Verify = () => {
  document.title = "Verifying your details...";

  const navigate = useNavigate();

  const { setSession } = useAppState((state: any) => ({
    setSession: state.setSession,
  }));

  const verify = async () => {
    try {
      const response = await auth.verifySession();
      const { user, session } = response.data as IConfirmResponse;
      if (user) {
        setSession(user, session);
        // If in a popup (SSO from Ghost iframe), notify parent and close
        if (window.opener && window.opener !== window) {
          window.opener.postMessage({
            type: 'AUTH_SUCCESS',
            data: { user, session }
          }, '*'); // For security, replace '*' with your Ghost CMS origin in production
          window.close();
          return;
        }
        navigate("/")
      }
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
      navigate("/login")
    }
  };

  useEffect(() => {
    verify();
  }, []);

  return (
    <>
      <div className="flex items-center justify-center">
        <p className="flex items-center space-x-2">
          <LoaderCircle className="h-4 w-4 animate-spin" />
          <span>
            {"Please wait..."}
          </span>
        </p>
      </div>
    </>
  );
};

export default Verify;
